import React from "react";
import AgentSelect from "../common/AgentSelect";
import { TYPE_OPTIONS, FUEL_OPTIONS } from "./transportCatalog";

function FilterField({ label, htmlFor, className = "", children }) {
  return (
    <div className={`package-filter-bar__field ${className}`.trim()}>
      <label className="package-filter-bar__label" htmlFor={htmlFor}>{label}</label>
      {children}
    </div>
  );
}

export default function TransportFilterBar({
  search,
  onSearchChange,
  onSearchSubmit,
  filters,
  onFilterChange,
}) {
  function setField(name, value) {
    onFilterChange({ ...filters, [name]: value });
  }

  return (
    <div className="package-filter-bar package-filter-bar--hotels" role="search">
      <FilterField label="Search" htmlFor="transport-filter-search" className="package-filter-bar__search">
        <input
          id="transport-filter-search"
          type="search"
          className="form-control"
          placeholder="Search vehicle name"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          onBlur={() => {
            if (typeof onSearchSubmit === "function") onSearchSubmit();
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && typeof onSearchSubmit === "function") onSearchSubmit();
          }}
        />
      </FilterField>

      <FilterField label="Type" htmlFor="transport-filter-type">
        <AgentSelect
          inputId="transport-filter-type"
          value={filters.typeName}
          options={TYPE_OPTIONS}
          onChange={(value) => setField("typeName", value)}
          placeholder="Type"
          isClearable
          isSearchable={false}
        />
      </FilterField>

      <FilterField label="Fuel Type" htmlFor="transport-filter-fuel">
        <AgentSelect
          inputId="transport-filter-fuel"
          value={filters.fuel}
          options={FUEL_OPTIONS}
          onChange={(value) => setField("fuel", value)}
          placeholder="Fuel type"
          isClearable
          isSearchable={false}
        />
      </FilterField>

      <FilterField label="Price Range" htmlFor="transport-filter-price-min" className="package-filter-bar__price">
        <div className="package-filter-range">
          <input
            id="transport-filter-price-min"
            type="number"
            min="0"
            inputMode="numeric"
            className="form-control"
            placeholder="Min"
            value={filters.priceMin}
            onChange={(event) => setField("priceMin", event.target.value)}
          />
          <span className="package-filter-range-sep">-</span>
          <input
            id="transport-filter-price-max"
            type="number"
            min="0"
            inputMode="numeric"
            className="form-control"
            placeholder="Max"
            value={filters.priceMax}
            onChange={(event) => setField("priceMax", event.target.value)}
          />
        </div>
      </FilterField>
    </div>
  );
}
